import { useMemo } from 'react';
import { FF, useFeatureFlagEnabled } from 'modules/feature-flags';
import {
  getWorklistItemStatusLabels,
  type WorklistItemStatusLabels,
} from 'utils/worklistItemStatus';

export const useWorklistItemStatusLabels = (): WorklistItemStatusLabels => {
  const [isReadyToReadEnabled] = useFeatureFlagEnabled(FF.WORKLIST_PENDING_TO_READY_TO_READ);
  return useMemo(() => {
    return getWorklistItemStatusLabels({ isReadyToReadEnabled });
  }, [isReadyToReadEnabled]);
};
